<div [style.backgroundColor]="color" class="named-icon d-flex align-items-center justify-content-center">
	<h1 class="m-0 named-icon__chars">{{ charToDisplay | uppercase }}</h1>
	<div class="named-icon__before-right">
		<ng-content select=".icon-before-right"></ng-content>
	</div>
</div>
